"use client";

import { Core } from "@faire/design-tokens";
import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated use `@faire/slate/icons/ClockSolid` instead (legacy Slate foundation icons cannot be deleted from code even if unused in frontend because they may be referenced to in Builder.io page data) */
export const ClockSolid = createSVGIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11m.982-14.929a.982.982 0 1 0-1.964 0V12c0 .23.08.452.227.629l3.93 4.714a.982.982 0 1 0 1.508-1.258l-3.7-4.44z"
    fill="currentColor"
    clipPath="url(#clip0_5414_954)"
  />,
  "ClockSolid",
  {
    color: Core.icon.default,
    fill: "none",
    viewBox: "0 0 24 24",
    className: legacyIconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
